<template>
  <a
    class="arrow pagelink"
    :class="`arrow--${direction}`"
    :data-theme="theme"
  >
    <div v-if="text" class="arrow__speach">
      {{ text }}
    </div>
    <div class="arrow__circle">
      <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- left -->
        <path
          v-if="direction === 'left'"
          d="M15.2009 11.5013L7.15989 11.5013L7.15989 14.7369L7.15989 15.7324L0.267578 8.26576L7.15989 0.799089L7.15989 1.79464L7.15989 5.27909L15.2009 5.27909L15.2009 11.5013Z"
        />
        <!-- right -->
        <path
          v-else-if="direction === 'right'"
          d="M0.799089 4.49869L8.84011 4.49869L8.84011 1.26313L8.84011 0.267578L15.7324 7.73424L8.84011 15.2009L8.84011 14.2054L8.84011 10.7209L0.799089 10.7209L0.799089 4.49869Z"
        />
        <!-- down -->
        <path
          v-else-if="direction === 'up'"
          d="M7.93333 28V12.9231H1.86667H0L14 0L28 12.9231H26.1333H19.6V28H7.93333Z"
        />
        <!-- down -->
        <path
          v-else
          d="M11.5013 0.799088V8.84011H14.7369H15.7324L8.26576 15.7324L0.799088 8.84011H1.79464H5.27909V0.799088H11.5013Z"
        />
      </svg>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Arrow',

  props: {
    direction: {
      default: () => 'down',
      type: String
    },
    text: {
      default: () => '',
      type: String
    },
    theme: {
      default: () => '',
      type: String
    }
  },

  computed: {
    size () {
      return (this.direction === 'up' ? 28 : 16)
    }
  }
}
</script>
